import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Swords, Plus } from "lucide-react";
import { toast } from "sonner";

const STATUS = { draft: "Bozza", pools: "Gironi", direct_elimination: "ED", completed: "Conclusa" };

/** Accesso rapido alla Simulazione Gara collegata a una seduta (crea se assente, riapre se esiste). */
export default function TrainingSimulationCard({ training, groups = [] }) {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/competitive-sessions`, { params: { training_id: training.id } }).then((r) => setItems(r.data || [])).catch(() => setItems([])); }, [training.id]);

  const create = async () => {
    const g = groups.find((x) => (training.group_ids || []).includes(x.id));
    const weapon = g?.weapon || (g?.weapons || [])[0] || null;
    try {
      const { data } = await api.post("/competitive-sessions", { name: `Simulazione · ${training.title}`, date: training.date, weapon, training_id: training.id, participants: [] });
      toast.success("Simulazione creata dalla seduta");
      nav(`/scherma/simulazione/${data.id}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Errore creazione"); }
  };

  return (
    <div className="bg-white border border-zinc-200 rounded-md p-4" data-testid="training-simulation-card">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="font-heading font-semibold text-sm flex items-center gap-2"><Swords className="w-4 h-4" />Simulazione Gara</div>
        <Button data-testid="training-sim-create" size="sm" variant="outline" onClick={create}><Plus className="w-4 h-4 mr-1" />Nuova dalla seduta</Button>
      </div>
      {items === null ? <div className="text-xs text-zinc-500 mt-2">Caricamento…</div> : items.length === 0 ? (
        <div className="text-xs text-zinc-500 mt-2" data-testid="training-sim-empty">Nessuna simulazione collegata a questa seduta.</div>
      ) : (
        <div className="mt-2 divide-y divide-zinc-100">
          {items.map((s) => (
            <button key={s.id} data-testid={`training-sim-open-${s.id}`} onClick={() => nav(`/scherma/simulazione/${s.id}`)} className="w-full flex items-center gap-3 py-2 text-sm text-left hover:bg-zinc-50">
              <span className="flex-1 truncate font-medium">{s.name}</span>
              <span className="text-xs text-zinc-500">{(s.participants || []).length} partecipanti</span>
              <span className="text-[11px] px-2 py-0.5 rounded-full bg-zinc-100">{STATUS[s.status] || s.status}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
